import styled from 'styled-components';
import { DatatableResultPage } from 'src/styled/index';

const Datatable2ResultPage = styled(DatatableResultPage)``;

export default Datatable2ResultPage;
export { Datatable2ResultPage };
